<template>
<div>
  <el-dialog  title="分段" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="fenduanFlag" width="1200px" center>
    <div  style="padding:12px">
      <div style="margin-bottom:20px">
        <div class="box2">
          <p>订单号：{{rowData.orderNo}}</p>
          <p>结算客户：{{rowData.payee}}</p>
          <p>货物：{{rowData.productTypeName}}/{{rowData.orderWeight}}{{rowData.measuringUnit}}</p>
          <p>收入计价：{{rowData.revenueValuationName}}</p>
          <p>收入单价：<span class="red">{{rowData.incomeUnitPrice}}</span>元/{{rowData.measuringUnit}}</p>
          <p>收入金额：<span class="red">{{rowData.incomeAmount}}</span>元</p>
        </div>
        <hr>
      </div>
      <el-form :inline="true" ref="dataFrom" enctype="multipart/form-data" :model="dataFrom" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
        <el-table height="450px" size="mini" ref="tabref" :data="dataFrom.orderList" style="width:100%" border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column property="orderNo"  width="150" :formatter="emptyFn"  label="子订单号"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.orderState===0||!scope.row.orderState">
              <el-button type="text" size="mini" v-if="scope.$index!=0" @click="delFN(scope.row,scope.$index)">删除</el-button>
              <el-button type="text" size="mini" @click="addTJDFn(scope.row,scope.$index)">增加途径点</el-button>
              <el-button type="text" size="mini" v-if="scope.$index+1!=dataFrom.orderList.length" @click="dizhiFn(scope.$index)">地址簿</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="收入单价"  min-width="120">
            <template slot="header" >
              <div><span class="red">*</span>收入单价</div>
            </template>
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.orderState===0||!scope.row.orderState">
                    <el-form-item v-if="rowData.revenueValuation!=1" label="" :prop="'orderList.' +scope.$index+ '.incomeUnitPrice'" :key="scope.$index" :rules="rules.incomeUnitPrice" class="table_error">
                      <el-input placeholder="" maxlength="10" v-number-input.float="2"
                        v-model.trim="dataFrom.orderList[scope.$index].incomeUnitPrice" @input="danjiaFN($event,scope.$index)" ></el-input>
                    </el-form-item>
                    <span  v-else>-</span>
                </div>
                <span  v-else>{{dataFrom.orderList[scope.$index].incomeUnitPrice}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="收入金额"  min-width="120">
            <template slot="header" >
              <div><span class="red">*</span>收入金额</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item v-if="scope.row.orderState===0||!scope.row.orderState" label="" :prop="'orderList.' +scope.$index+ '.incomeAmount'" :key="scope.$index" :rules="rules.incomeAmount" class="table_error">
                  <el-input placeholder="" maxlength="10" v-number-input.float="2"
                    v-model.trim="dataFrom.orderList[scope.$index].incomeAmount" :readonly="rowData.revenueValuation!=1" ></el-input>
                </el-form-item>
                 <span  v-else>{{dataFrom.orderList[scope.$index].incomeAmount}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="startDirection" width="220"  label="始发流向"></el-table-column>
          <el-table-column property="endDirection" width="220"  label="目的流向"></el-table-column>
          <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}</span>
              <span>{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span>{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
        </el-table>
    </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button  @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="saveFn">提交</el-button>
    </span>
  </el-dialog>
   <el-dialog  title="选择地址" :close-on-click-modal="false" :close-on-press-escape="false"  @close="dialogVisible = false"
    :visible.sync="dialogVisible" width="1300px" center append-to-body>
    <div>
      <publicAddress v-if="dialogVisible" :iszujian="1" @handleCurrentChange="handleCurrentChange"></publicAddress>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { sectionOpenOrde, findSonSectionList, deleteSectionCheckv, updateSectionOpenOrde } from '@/api/newTMS'
import publicAddress from '@/views/newTMS/publicFiles/publicAddress.vue'
import { toFixed, emptyFn } from '@/utils/util'
export default {
  name: 'zhipaiyouhuo',
  components: {
    publicAddress
  },
  props: {
    fenduanFlag: {
      type: Boolean,
      default: false
    },
    rowDataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      emptyFn: emptyFn,
      dataFrom: { orderList: [] },
      rules: {
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ]
      },
      rowData: this.rowDataList[0],
      dialogVisible: false,
      index: 0,
      delIds: []

    }
  },

  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    let row = this.rowData
    if (row.stowageType == 2) {
      findSonSectionList({ orderId: row.orderId, orderBusinessId: row.orderBusinessId }).then((res) => {
        this.$set(this.dataFrom, 'orderList', res)
      })
    } else {
      this.dataFrom.orderList.push({})
      this.$set(this.dataFrom.orderList[0], 'incomePattern', row.incomePattern)
      this.$set(this.dataFrom.orderList[0], 'revenueValuation', row.revenueValuation)
      this.$set(this.dataFrom.orderList[0], 'receivingCompany', row.receivingCompany)
      this.$set(this.dataFrom.orderList[0], 'receivingPerson', row.receivingPerson)
      this.$set(this.dataFrom.orderList[0], 'receivingPhone', row.receivingPhone)
      this.$set(this.dataFrom.orderList[0], 'receivingAddress', row.receivingAddress)
      this.$set(this.dataFrom.orderList[0], 'endDirection', row.endDirection)
      this.dataFrom.orderList[0].receivingProvinceCode = row.receivingProvinceCode
      this.dataFrom.orderList[0].receivingCityCode = row.receivingCityCode
      this.dataFrom.orderList[0].receivingAreaCode = row.receivingAreaCode
      this.dataFrom.orderList[0].receivingProvinceName = row.receivingProvinceName
      this.dataFrom.orderList[0].receivingCityName = row.receivingCityName
      this.dataFrom.orderList[0].receivingAreaName = row.receivingAreaName
      this.dataFrom.orderList[0].receivingAddressId = row.receivingAddressId
      this.dataFrom.orderList[0].receivingLongitude = row.receivingLongitude
      this.dataFrom.orderList[0].receivingLatitude = row.receivingLatitude
      this.$set(this.dataFrom.orderList[0], 'deliverCompany', row.deliverCompany)
      this.$set(this.dataFrom.orderList[0], 'deliverPerson', row.deliverPerson)
      this.$set(this.dataFrom.orderList[0], 'deliverPhone', row.deliverPhone)
      this.$set(this.dataFrom.orderList[0], 'deliverAddress', row.deliverAddress)
      this.$set(this.dataFrom.orderList[0], 'startDirection', row.startDirection)
      this.dataFrom.orderList[0].deliverProvinceCode = row.deliverProvinceCode
      this.dataFrom.orderList[0].deliverCityCode = row.deliverCityCode
      this.dataFrom.orderList[0].deliverAreaCode = row.deliverAreaCode
      this.dataFrom.orderList[0].deliverProvinceName = row.deliverProvinceName
      this.dataFrom.orderList[0].deliverCityName = row.deliverCityName
      this.dataFrom.orderList[0].deliverAreaName = row.deliverAreaName
      this.dataFrom.orderList[0].deliverAddressId = row.deliverAddressId
      this.dataFrom.orderList[0].deliverLongitude = row.deliverLongitude
      this.dataFrom.orderList[0].deliverLatitude = row.deliverLatitude
    }
  },
  methods: {
    // 输入价格
    danjiaFN (e, index) {
      if (this.rowData.revenueValuation != 1) {
        console.log(this.rowData.orderWeight, e)
        let n = toFixed(accMul(this.rowData.orderWeight, e), 2)
        this.$set(this.dataFrom.orderList[index], 'incomeAmount', n)
      }
      function accMul (arg1, arg2) {
        var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
        try {
          m += s1.split('.')[1].length
        } catch (e) {
        }
        try {
          m += s2.split('.')[1].length
        } catch (e) {
        }

        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
      }
    },
    // 地址薄
    dizhiFn (index) {
      this.index = index
      this.dialogVisible = true
    },
    handleCurrentChange (row) {
      let index = this.index
      if (row.id == this.dataFrom.orderList[index].deliverAddressId || row.id == this.dataFrom.orderList[index + 1].receivingAddressId) {
        this.$alert('途径点地址不能与发货地址和收货地址重复', '系统提示')
        return
      }
      // 收货
      this.$set(this.dataFrom.orderList[index], 'receivingCompany', row.company)
      this.$set(this.dataFrom.orderList[index], 'receivingPerson', row.person)
      this.$set(this.dataFrom.orderList[index], 'receivingPhone', row.phone)
      this.$set(this.dataFrom.orderList[index], 'receivingAddress', row.address)
      this.$set(this.dataFrom.orderList[index], 'endDirection', row.name)
      this.dataFrom.orderList[index].receivingProvinceCode = row.provinceCode
      this.dataFrom.orderList[index].receivingCityCode = row.cityCode
      this.dataFrom.orderList[index].receivingAreaCode = row.areaCode
      this.dataFrom.orderList[index].receivingProvinceName = row.provinceName
      this.dataFrom.orderList[index].receivingCityName = row.cityName
      this.dataFrom.orderList[index].receivingAreaName = row.areaName
      this.dataFrom.orderList[index].receivingAddressId = row.id
      this.dataFrom.orderList[index].receivingLongitude = row.longitude
      this.dataFrom.orderList[index].receivingLatitude = row.latitude
      console.log(this.dataFrom.orderList)
      // 发货
      this.$set(this.dataFrom.orderList[index + 1], 'deliverCompany', row.company)
      this.$set(this.dataFrom.orderList[index + 1], 'deliverPerson', row.person)
      this.$set(this.dataFrom.orderList[index + 1], 'deliverPhone', row.phone)
      this.$set(this.dataFrom.orderList[index + 1], 'deliverAddress', row.address)
      this.$set(this.dataFrom.orderList[index + 1], 'startDirection', row.name)
      this.dataFrom.orderList[index + 1].deliverProvinceCode = row.provinceCode
      this.dataFrom.orderList[index + 1].deliverCityCode = row.cityCode
      this.dataFrom.orderList[index + 1].deliverAreaCode = row.areaCode
      this.dataFrom.orderList[index + 1].deliverProvinceName = row.provinceName
      this.dataFrom.orderList[index + 1].deliverCityName = row.cityName
      this.dataFrom.orderList[index + 1].deliverAreaName = row.areaName
      this.dataFrom.orderList[index + 1].deliverAddressId = row.id
      this.dataFrom.orderList[index + 1].deliverLongitude = row.longitude
      this.dataFrom.orderList[index + 1].deliverLatitude = row.latitude
      this.dialogVisible = false
    },
    // 添加途径点
    addTJDFn (row, index) {
      let json = { }
      // 下一条数据收货地址
      this.$set(json, 'incomePattern', row.incomePattern)
      this.$set(json, 'revenueValuation', row.revenueValuation)
      this.$set(json, 'receivingCompany', row.receivingCompany)
      this.$set(json, 'receivingPerson', row.receivingPerson)
      this.$set(json, 'receivingPhone', row.receivingPhone)
      this.$set(json, 'receivingAddress', row.receivingAddress)
      this.$set(json, 'endDirection', row.endDirection)
      json.receivingProvinceCode = row.receivingProvinceCode
      json.receivingCityCode = row.receivingCityCode
      json.receivingAreaCode = row.receivingAreaCode
      json.receivingProvinceName = row.receivingProvinceName
      json.receivingCityName = row.receivingCityName
      json.receivingAreaName = row.receivingAreaName
      json.receivingAddressId = row.receivingAddressId
      json.receivingLongitude = row.receivingLongitude
      json.receivingLatitude = row.receivingLatitude
      // 下一条数据的发货地址为空
      this.$set(json, 'deliverCompany', '')
      this.$set(json, 'deliverPerson', '')
      this.$set(json, 'deliverPhone', '')
      this.$set(json, 'deliverAddress', '')
      this.$set(json, 'startDirection', '')
      json.deliverProvinceCode = ''
      json.deliverCityCode = ''
      json.deliverAreaCode = ''
      json.deliverProvinceName = ''
      json.deliverCityName = ''
      json.deliverAreaName = ''
      json.deliverAddressId = ''
      json.deliverLongitude = ''
      json.deliverLatitude = ''
      this.dataFrom.orderList.splice(index + 1, 0, json)
      // 清空本条数据收货地址
      this.$set(this.dataFrom.orderList[index], 'receivingCompany', '')
      this.$set(this.dataFrom.orderList[index], 'receivingPerson', '')
      this.$set(this.dataFrom.orderList[index], 'receivingPhone', '')
      this.$set(this.dataFrom.orderList[index], 'receivingAddress', '')
      this.$set(this.dataFrom.orderList[index], 'endDirection', '')
      this.dataFrom.orderList[index].receivingProvinceCode = ''
      this.dataFrom.orderList[index].receivingCityCode = ''
      this.dataFrom.orderList[index].receivingAreaCode = ''
      this.dataFrom.orderList[index].receivingProvinceName = ''
      this.dataFrom.orderList[index].receivingCityName = ''
      this.dataFrom.orderList[index].receivingAreaName = ''
      this.dataFrom.orderList[index].receivingAddressId = ''
      this.dataFrom.orderList[index].receivingLongitude = ''
      this.dataFrom.orderList[index].receivingLatitude = ''
    },
    // 删除
    delFN (row, index) {
      let that = this
      if (row.orderId) {
        deleteSectionCheckv({ orderBusinessId: row.orderBusinessId }).then(res => {
          this.delIds.push(row.orderBusinessId)
          fuzhi()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        fuzhi()
      }
      function fuzhi () {
        that.$set(that.dataFrom.orderList[index - 1], 'receivingCompany', row.deliverCompany)
        that.$set(that.dataFrom.orderList[index - 1], 'receivingPerson', row.deliverPerson)
        that.$set(that.dataFrom.orderList[index - 1], 'receivingPhone', row.deliverPhone)
        that.$set(that.dataFrom.orderList[index - 1], 'receivingAddress', row.deliverAddress)
        that.$set(that.dataFrom.orderList[index - 1], 'endDirection', row.endDirection)
        that.dataFrom.orderList[index - 1].receivingProvinceCode = row.receivingProvinceCode
        that.dataFrom.orderList[index - 1].receivingCityCode = row.receivingCityCode
        that.dataFrom.orderList[index - 1].receivingAreaCode = row.receivingAreaCode
        that.dataFrom.orderList[index - 1].receivingProvinceName = row.receivingProvinceName
        that.dataFrom.orderList[index - 1].receivingCityName = row.receivingCityName
        that.dataFrom.orderList[index - 1].receivingAreaName = row.receivingAreaName
        that.dataFrom.orderList[index - 1].receivingAddressId = row.receivingAddressId
        that.dataFrom.orderList[index - 1].receivingLongitude = row.receivingLongitude
        that.dataFrom.orderList[index - 1].receivingLatitude = row.receivingLatitude
        that.dataFrom.orderList.splice(index, 1)
      }
    },
    // 保存
    saveFn () {
      this.$refs.dataFrom.validate((valid) => {
        if (valid) {
          if (this.dataFrom.orderList.length < 2) {
            this.$alert('请至少增加一个途径点', '系统提示')
            return
          }
          let list = []
          let flag = false
          this.dataFrom.orderList.forEach((item, index) => {
            if (!item.receivingAddressId || !item.deliverAddressId) {
              flag = false
              return false
            } else {
              item.orderAce = index + 1
              list.push(item)
              flag = true
            }
          })
          if (!flag) {
            this.$alert('请选择地址', '系统提示')
            return
          }
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.rowData.stowageType == 2) {
            updateSectionOpenOrde({
              orderBusinessId: this.rowData.orderBusinessId,
              sectionList: list,
              deleteOrderBusinessIds: this.delIds
            }).then(res => {
              loading.close()
              this.$emit('update:fenduanFlag', false)
              this.$parent.searchFn()
              this.$parent.tableKey += 1
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            sectionOpenOrde({
              orderBusinessId: this.rowData.orderBusinessId,
              sectionList: list
            }).then(res => {
              loading.close()
              this.$emit('update:fenduanFlag', false)
              this.$parent.searchFn()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    closeDialog () {
      this.$emit('update:fenduanFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.box2{
  display: flex;
  flex-wrap:wrap;
  p{
    margin-right: 30px;
    margin-top: 0;
  }
}
.box1{
  padding-right: 60px;
  /deep/ .icon{
    font-size: 24px;
    color:#0c46a2 ;
  }
}
.el-form-item {
    margin-left: 0px;
}
</style>
